import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { fetchCompanyDocuments } from '../../Documents/actions';
import { DocumentsList } from '../../Documents/components/documentsList';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {
  items: null,
};
/* eslint-disable react/prefer-stateless-function */
class CompanyDocumentsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.isInvoice &&
      this.props.fetch(res => {
        if (res?.length) {
          this.setState({ items: res });
        }
      });
  }

  renderInvoiceDocs() {
    return (
      <Card className="company-info-card info-card data">
        <Container>
          <h2>{this.lbl('company.info.documents.title')}</h2>
          {this.state.items && (
            <DocumentsList
              DocumentsList
              entityId={this.props.company?.id}
              entityType="company"
              items={this.state.items}
            ></DocumentsList>
          )}
        </Container>
      </Card>
    );
  }

  render() {
    const company = this.props.company;

    if (this.props.isInvoice) {
      return this.renderInvoiceDocs();
    }
    return (
      <Card className="company-info-card info-card data">
        <Container>
          <h2>{this.lbl('company.info.documents.title')}</h2>
          <DocumentsList entityId={company?.id} entityType="company" items={company?.documents}></DocumentsList>
        </Container>
      </Card>
    );
  }
}

CompanyDocumentsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(callback) {
      dispatch(fetchCompanyDocuments(ownProps.company?.id, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const CompanyDocumentsCard = compose(
  withConnect,
  withRouter,
)(CompanyDocumentsCardComp);
